// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userAccountFormStyles } from "@guestsupply/App/Components/UserAccountForm/UserAccountForm";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

userAccountFormStyles.formWrapper = {
    css: css`
        margin-bottom: 30px;
    `,
};
userAccountFormStyles.formFieldsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 22px;
        justify-content: space-between;
    `,
};
userAccountFormStyles.fieldWrapper = {
    css: css`
        width: calc(100% / 3 - 15px);
        ${xScreen("lte", "md")} {
            width: calc(50% - 11px);
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
userAccountFormStyles.phonesFieldWrapper = {
    css: css`
        width: calc(100% / 3 - 15px);
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        ${xScreen("lte", "md")} {
            width: calc(50% - 11px);
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
userAccountFormStyles.phoneFieldWrapper = {
    css: css`
        display: flex;
        gap: 15px;
        width: 100%;
    `,
};
userAccountFormStyles.phoneNumberLabel = {
    lineHeight: "13px",
    size: 12,
    weight: 500,
    css: css`
        width: 100%;
        margin: 8px 0;
    `,
};
userAccountFormStyles.titleWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
userAccountFormStyles.sectionTitle = {
    css: css`
        margin-bottom: 0;
    `,
};
userAccountFormStyles.removeAdditionalUserLink = {
    css: css`
        height: 16px;
        ${IconWrapper}, svg {
            color: ${color("primary")};
            width: 14px;
            height: 16px;
            line-height: 17px;
            &:hover {
                opacity: 0.5;
            }
        }
    `,
};
